import firebase from "firebase/app";
import React from "react";

import { AnalyticsEventEnum } from "@/consts/AnalyticsEventEnum";
import { OutlinedButton } from "@/features/common/components/button/OutlinedButton";
import { useUserContext } from "@/features/user/contexts/useUserContext";
import { SubscriptionPlanFullFragment } from "@/generated/generated-hooks";

export type JoinSubscriptionButtonProps = {
  subscriptionPlan: SubscriptionPlanFullFragment;
  onClickSubscribe: () => void;
  label: string;
};

export function JoinSubscriptionButton(props: JoinSubscriptionButtonProps) {
  const {
    label,
    onClickSubscribe,
    subscriptionPlan: { title, _id },
  } = props;

  const { user } = useUserContext();

  /* onClickJoinButton */
  const onClickHandler = () => {
    if (!user) return alert("Login Required!");
    firebase
      .analytics()
      .logEvent(AnalyticsEventEnum.SubscriptionCardClickSubscribe, {
        subscriptionPlanId: _id,
        subscriptionPlanTitle: title,
      });
    onClickSubscribe();
  };

  return (
    <OutlinedButton
      variant="primary"
      fullWidth
      buttonProps={{ onClick: onClickHandler }}
    >
      {label}
    </OutlinedButton>
  );
}
